"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
var _vue = _interopRequireDefault(require("vue"));
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var requireComponent1 = require.context('.', true, /\.vue$/
// 找到当前文件夹下以.vue命名的文件
);

/* components下无目录 */
// requireComponent.keys().forEach(fileName => {
//   const componentConfig = requireComponent(fileName)
//
//   const componentName = capitalizeFirstLetter(
//     fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
//     //因为得到的filename格式是: './dataList.vue', 所以这里我们去掉头和尾，只保留真正的文件名
//   )
//   Vue.component(componentName, componentConfig.default || componentConfig)
// })

/* components下有目录 */
requireComponent1.keys().forEach(function (fileName) {
  var componetConfig = requireComponent1(fileName);
  var a = fileName.lastIndexOf('/');
  fileName = fileName.slice(0, a);
  var componetName = capitalizeFirstLetter(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''));
  _vue.default.component(componetName, componetConfig.default || componetConfig);
});